if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        //this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');
        const selectedItems = Array.from(this.form.elements).flatMap((control) => {
          if (!control.hasAttribute('data-inverawe-multivariant-item') || control.matches(':disabled')) return [];
          const match = /^items\[(\d+)\]\[id\]$/.exec(control.name);
          const value = formData.get(control.name);
          if (!match || typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) return [];
          const quantity = Number(formData.get(`items[${match[1]}][quantity]`));
          return Number.isInteger(quantity) && quantity > 0 ? [{ index: match[1], id: value }] : [];
        });
        const lineMetadata = new Map();
        for (const [name, value] of formData.entries()) {
          if (name !== 'selling_plan' && !/^properties\[.+\]$/.test(name)) continue;
          if (!lineMetadata.has(name)) lineMetadata.set(name, []);
          lineMetadata.get(name).push(value);
        }
        const primaryItem = selectedItems.find((item) => item.id === productVariantId);
        let canMoveMetadata = lineMetadata.size === 0 || Boolean(primaryItem);
        const metadataMoves = [];
        if (primaryItem) {
          for (const [name, values] of lineMetadata) {
            const target = name === 'selling_plan'
              ? `items[${primaryItem.index}][selling_plan]`
              : `items[${primaryItem.index}][properties]${name.slice('properties'.length)}`;
            const existing = formData.getAll(target);
            if (existing.length && (existing.length !== values.length || existing.some((value, index) => value !== values[index]))) {
              canMoveMetadata = false;
            }
            metadataMoves.push({ name, target, values });
          }
        }
        const normalizeMultivariantRequest = selectedItems.length > 0 && canMoveMetadata;
        if (normalizeMultivariantRequest) {
          for (const { name, target, values } of metadataMoves) {
            if (!formData.has(target)) values.forEach((value) => formData.append(target, value));
            formData.delete(name);
          }
          formData.delete('id');
          formData.delete('quantity');
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId, cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
